import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isProjectHistoryPushRequestFailure() {
      return getState().isFailure;
    },
    isProjectHistoryPushRequestPending() {
      return getState().isPending;
    },
    isProjectHistoryPushRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
